import React from 'react';
import {
  Box,
  Container,
  Typography,
  Card,
  CardContent,
  Grid,
  TextField,
  Button,
  Switch,
  FormControlLabel,
  Divider,
} from '@mui/material';
import { Save } from '@mui/icons-material';
import Header from '../components/Header';
import Sidebar from '../components/Sidebar';

const SettingsPage: React.FC = () => {
  return (
    <Box sx={{ display: 'flex', minHeight: '100vh', bgcolor: '#f5f5f5' }}>
      <Sidebar />
      <Box sx={{ flex: 1, display: 'flex', flexDirection: 'column' }}>
        <Header />
        <Box component="main" sx={{ flex: 1, p: 3 }}>
          <Container maxWidth="xl">
            <Typography variant="h4" sx={{ fontWeight: 700, mb: 3 }}>
              Settings
            </Typography>

            <Grid container spacing={3}>
              {/* Organization Settings */}
              <Grid item xs={12} md={6}>
                <Card sx={{ borderRadius: 3 }}>
                  <CardContent>
                    <Typography variant="h6" sx={{ fontWeight: 600, mb: 2 }}>
                      Organization Settings
                    </Typography>
                    <TextField
                      fullWidth
                      label="Organization Name"
                      defaultValue="Sakura Hospital"
                      sx={{ mb: 2 }}
                    />
                    <TextField
                      fullWidth
                      label="Timezone"
                      defaultValue="UTC+01:00"
                      sx={{ mb: 2 }}
                    />
                    <TextField
                      fullWidth
                      label="Date Format"
                      defaultValue="YYYY-MM-DD"
                      sx={{ mb: 2 }}
                    />
                    <Button variant="contained" startIcon={<Save />} sx={{ bgcolor: '#E91E63' }}>
                      Save Changes
                    </Button>
                  </CardContent>
                </Card>
              </Grid>

              {/* Notification Settings */}
              <Grid item xs={12} md={6}>
                <Card sx={{ borderRadius: 3 }}>
                  <CardContent>
                    <Typography variant="h6" sx={{ fontWeight: 600, mb: 2 }}>
                      Notification Settings
                    </Typography>
                    <FormControlLabel
                      control={<Switch defaultChecked />}
                      label="Email notifications for new shift requests"
                      sx={{ display: 'block', mb: 1 }}
                    />
                    <FormControlLabel
                      control={<Switch defaultChecked />}
                      label="Push notifications for schedule changes"
                      sx={{ display: 'block', mb: 1 }}
                    />
                    <FormControlLabel
                      control={<Switch />}
                      label="SMS notifications for urgent shifts"
                      sx={{ display: 'block', mb: 1 }}
                    />
                    <FormControlLabel
                      control={<Switch defaultChecked />}
                      label="Daily digest emails"
                      sx={{ display: 'block', mb: 1 }}
                    />
                  </CardContent>
                </Card>
              </Grid>

              {/* Shift Settings */}
              <Grid item xs={12}>
                <Card sx={{ borderRadius: 3 }}>
                  <CardContent>
                    <Typography variant="h6" sx={{ fontWeight: 600, mb: 2 }}>
                      Shift Configuration
                    </Typography>
                    <Grid container spacing={2}>
                      <Grid item xs={12} sm={4}>
                        <TextField
                          fullWidth
                          label="Morning Shift Start"
                          type="time"
                          defaultValue="07:00"
                          InputLabelProps={{ shrink: true }}
                        />
                      </Grid>
                      <Grid item xs={12} sm={4}>
                        <TextField
                          fullWidth
                          label="Afternoon Shift Start"
                          type="time"
                          defaultValue="15:00"
                          InputLabelProps={{ shrink: true }}
                        />
                      </Grid>
                      <Grid item xs={12} sm={4}>
                        <TextField
                          fullWidth
                          label="Night Shift Start"
                          type="time"
                          defaultValue="23:00"
                          InputLabelProps={{ shrink: true }}
                        />
                      </Grid>
                    </Grid>
                    <Divider sx={{ my: 2 }} />
                    <Grid container spacing={2}>
                      <Grid item xs={12} sm={6}>
                        <TextField
                          fullWidth
                          label="Max Hours Per Week"
                          type="number"
                          defaultValue={40}
                        />
                      </Grid>
                      <Grid item xs={12} sm={6}>
                        <TextField
                          fullWidth
                          label="Min Rest Between Shifts (hours)"
                          type="number"
                          defaultValue={8}
                        />
                      </Grid>
                    </Grid>
                    <Button variant="contained" startIcon={<Save />} sx={{ mt: 2, bgcolor: '#E91E63' }}>
                      Save Shift Settings
                    </Button>
                  </CardContent>
                </Card>
              </Grid>
            </Grid>
          </Container>
        </Box>
      </Box>
    </Box>
  );
};

export default SettingsPage;
